import {
  CallerInfo,
  CallDirection,
  Channel,
  Modality,
  TaskFlowDetails,
  ConversationCodesInfo,
} from '@nimbus-assistant/models/task-types.model';
import { TeamInfo } from '@nimbus-assistant/models/team-info';
import { ConversationOriginType } from '@nimbus-library/features/shared/models/participant-info/i-combined-conversation.response';
import { ConsultationSession } from '@nimbus-library/features/shared/models/participant-info/i-combined-conversation.response';
import { ConversationTaskType } from '@nimbus-global/features/reportingLiveData/models/task-type.enum';

export enum TaskState {
  Ringing = 'Ringing',
  Connected = 'Connected',
  Parked = 'Parked',
  InACW = 'InACW',
  InExtendedACW = 'InExtendedACW',
}

export enum TaskConversationState {
  Selected = 'Selected',
  DialingOut = 'DialingOut',
  Ongoing = 'Ongoing',
  Transferring = 'Transferring',
  PutOnHold = 'PutOnHold',
  Parked = 'Parked',
  InAfterCallWork = 'InAfterCallWork',
  InExtendedAfterCallWork = 'InExtendedAfterCallWork',
  Terminated = 'Terminated',
}

export interface ITaskAcwInfo {
  /** Seconds remaining until the ACW timeout, derived from `started` and `durationInSeconds`. */
  leftInSeconds: number;
  /** Total ACW duration granted for the current (possibly extended) ACW period. */
  durationInSeconds: number;
  /** When the current ACW period started (session `since`). */
  started: string;
  extended: string;
  allowToStop: boolean;
  allowToExtend: boolean;
}

export interface ITask {
  // Identity
  unifiedConversationId: string;
  conversationId: string;
  userSessionId: string;

  // State
  state: TaskState;
  conversationState: TaskConversationState;
  since: string;
  acceptedAt: string;
  orderNumber: number;

  // Modality & Channel
  modality: Modality;
  channel: Channel;
  direction: CallDirection;
  taskType?: ConversationTaskType;

  // Caller
  caller: CallerInfo;

  // Service / Team
  teamId: string;
  initialServiceName: string;
  teamInfo: TeamInfo;
  originType: ConversationOriginType;

  // Supplementary data (populated by tabs, not by loadTasks)
  callFlow?: TaskFlowDetails[];
  conversationCodes?: ConversationCodesInfo;
  contextData?: { key: string; value: string; isUrl: boolean }[];
  customContextParameters?: Record<string, string>;
  resolvedParameters?: Record<string, string>;
  agentChatDeepLink?: string;

  // Flags
  isInternal: boolean;
  isExternal: boolean;
  isServiceCall: boolean;
  isDirectCall: boolean;
  isSupervision: boolean;
  startedWithTransfer: boolean;
  // ACW (only when state = InACW/InExtendedACW)
  afterCallWork?: ITaskAcwInfo;

  // Consultation
  consultationSession?: ConsultationSession;

  // Conference state
  callerHungUpAt?: string;
}
